/**
 * Where the shared printer service learns which printer is active.
 *
 * The store owns the selection and imports the service; the service must not
 * import the store back (an import cycle). So the store registers a getter
 * here at module load, and the service reads through it. Until something
 * registers, there is no active printer — the fail-closed answer.
 */
import type { SavedPrinter } from './printer-types';

let source: () => SavedPrinter | null = () => null;

/** Registered once by `usePrinterStore`; tests may register their own. */
export function setActivePrinterSource(next: () => SavedPrinter | null): void {
  source = next;
}

export function getActivePrinter(): SavedPrinter | null {
  return source();
}
